import { render, staticRenderFns } from "./VaimoMenuLayer.vue?vue&type=template&id=bfd26258&scoped=true&"
import script from "./VaimoMenuLayer.vue?vue&type=script&lang=ts&"
export * from "./VaimoMenuLayer.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoMenuLayer.vue?vue&type=style&index=0&id=bfd26258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd26258",
  null
  
)

export default component.exports